<template>
  <div id="toast" :class="[isActive ? 'active' : '', type]">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: "Toast",
  data() {
    return {
      message: "",//传递的消息
      isActive: false,//是否处于活跃状态（显示在页面内）
      type: "",//消息样式
      timer1: null,
      timer2: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.isActive = true;
    });
    this.timer1 = setTimeout(() => {
      this.isActive = false;
    }, this.delayer);
    this.timer2 = setTimeout(() => {
      this.$destroy(true);//销毁vue实例
    }, this.delayer * 2);
  },
  destroyed() {
    this.$el.parentNode.removeChild(this.$el);//移除dom元素
    clearTimeout(this.timer1);
    clearTimeout(this.timer2);
  },
};
</script>

<style scoped>
#toast {
  position: fixed;
  top: -50px;
  left: 50%;
  transform: translate(-50%, 0);
  padding: 0.13rem 0.2rem;
  border-radius: 0.1rem;
  z-index: 999;
  opacity: 0;
  transition: all 1s;
}
#toast.success {
  background-color:#000000;
  color: white;
}
#toast.error {
  background-color: #fef0f0;
  color: #f56c6c;
}
#toast.active {
  top: 30px;
  opacity: 1;
}
</style>




// WEBPACK FOOTER //
// src/components/toast.vue